// extracted by mini-css-extract-plugin
module.exports = {"dashbStyled":"DashboardPage_dashbStyled__cs_c-","SectionName":"DashboardPage_SectionName__2FH87","DashboardBackground":"DashboardPage_DashboardBackground__tean1"};